import { formatMoney } from 'accounting-js'

export default function (value) {
  return formatMoney(value, {
    symbol: 'Ft',
    format: '%v %s',
    thousand: ' ',
    precision: 0
  })
}



// WEBPACK FOOTER //
// ./src/filters/currency.js